import { render, staticRenderFns } from "./RenameCategory.vue?vue&type=template&id=6ba8b700&"
import script from "./RenameCategory.vue?vue&type=script&lang=js&"
export * from "./RenameCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports